export default {
  "HitPaw Add Music to Audio Online": "HitPaw Добавить музыку в аудио онлайн",
  "Add BGM to Audio without any difficulties.": "Добавляйте фоновую музыку в аудио без каких-либо проблем.",
  "Add New": "Добавить новое",
  "Format": "Формат",
  "Add tracks": "Добавить треки",

};
